import React, { FC } from 'react'
import { useHistory } from 'react-router'
import classNames from 'classnames'
import { Tag, TAG_SIZE, TAG_STYLE } from 'transfix-ui/components/Tag'
import { Box, createStyles, makeStyles, Typography } from 'transfix-ui/core'
import Skeleton from 'transfix-ui/core/Skeleton'
import { brandColors } from 'transfix-ui/theme/colors'
import { useBreakpointContext } from 'utils/context/BreakpointContext'
import { useBidsApi } from 'apps/fleet-planner/hooks/useBidsApi'
import { useFMSAnalytics } from 'apps/fleet-planner/hooks/useFMSAnalytics'
import { PriceIcon } from 'transfix-icons'
import { BookableShipmentSavedSearchTile } from './BookableShipmentSavedSearchTile'

interface IBookableShipmentSavedSearchBidTileProps {
  isLoading: boolean
}

const useStyles = makeStyles(theme => {
  return createStyles({
    labelTwo: {
      color: brandColors.coolGray6,
    },
    icon: {
      marginLeft: '5px',
      marginTop: '10px',
    },
    iconContainer: {
      height: '85px',
      width: '85px',
      marginBottom: theme.spacing(1),
    },
    tileContainer: {
      width: '85px',
      textAlign: 'center',
      margin: 'auto',
    },
  })
})

export const BookableShipmentSavedSearchBidTile: FC<IBookableShipmentSavedSearchBidTileProps> = ({
  isLoading,
}) => {
  const { trackEvent } = useFMSAnalytics()
  const { acceptedBidsCount, pendingBidsCount } = useBidsApi()
  const { isMobile } = useBreakpointContext()

  const history = useHistory()
  const classes = useStyles()

  const acceptedBidsCountStr =
    acceptedBidsCount === 1
      ? `${acceptedBidsCount} load to book`
      : `${acceptedBidsCount} loads to book`

  const pendingBidsCountStr =
    pendingBidsCount === 1 ? `${pendingBidsCount} pending bid` : `${pendingBidsCount} pending bids`

  const clickHandler = () => {
    trackEvent('Book Load', 'CLICKED_MY_BIDS')
    history.push('/bids')
  }

  const countStr = !acceptedBidsCount || isMobile ? '' : acceptedBidsCountStr
  const tileContainer = classNames({
    [classes.tileContainer]: isMobile,
  })

  return (
    <BookableShipmentSavedSearchTile
      dataTest='transfix-lanes-bid-tile'
      isLoading={isLoading}
      onClick={clickHandler}
      countStr={countStr}
      variant='mobile'
      header={
        <Box className={tileContainer}>
          {!isMobile && (
            <>
              <Typography variant='subtitle1'>Manage My Bids</Typography>
              {isLoading ? (
                <Skeleton width='100%' />
              ) : (
                <Typography className={classes.labelTwo} variant='body2'>
                  {pendingBidsCountStr}
                </Typography>
              )}
            </>
          )}
          {isMobile && (
            <>
              <Tag
                label={<PriceIcon size='xxlarge' className={classes.icon} />}
                tagStyle={TAG_STYLE.info}
                size={TAG_SIZE.large}
                className={classes.iconContainer}
              />
              <Typography variant='subtitle1'>Manage My Bids</Typography>
            </>
          )}
        </Box>
      }
    />
  )
}
